import { useEffect, useRef } from "react";
import { Row } from "@tanstack/react-table";
import { Toggle } from "@/components/custom/toggle";
import { SingleSelectColumnOptions } from "./data-table-single-select-column";

export const SingleSelectCell = ({
  row,
  options,
}: {
  row: Row<unknown>;
  options: SingleSelectColumnOptions;
}) => {
  const isDisabled = options.getIsDisabled?.(row) ?? false;
  const isSelected = row.getIsSelected();
  const initializedRef = useRef(false);

  // Handle initial selection
  useEffect(() => {
    if (!initializedRef.current && options.getIsInitiallySelected) {
      const shouldBeInitiallySelected = options.getIsInitiallySelected(row);
      if (shouldBeInitiallySelected && !isDisabled && !isSelected) {
        row.toggleSelected(true);
      }
      initializedRef.current = true;
    }
  }, [row, options, isDisabled, isSelected]);

  // Auto-deselect if row becomes disabled while selected
  useEffect(() => {
    if (isDisabled && isSelected) {
      row.toggleSelected(false);
    }
  }, [isDisabled, isSelected, row]);

  return (
    <Toggle
      variant="round_dot"
      size="xs"
      pressed={isSelected}
      disabled={isDisabled}
      onClick={(ev) => ev.stopPropagation()}
      onPressedChange={() => {
        if (!isDisabled) {
          row.toggleSelected(true);
        }
      }}
      aria-label="Select row"
      className="translate-y-[2px]"
    />
  );
};
